module.exports = __webpack_public_path__ + "img/art.d7ae5bae.png";